var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 50,
    height: 50,
    rx: 12,
    fill: "#385CC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6108 30.2799L28.3788 34.1199H29.7998C30.0649 34.1199 30.2798 34.3348 30.2798 34.5999C30.2798 34.865 30.0649 35.0799 29.7998 35.0799H20.1998C19.9347 35.0799 19.7198 34.865 19.7198 34.5999C19.7198 34.3348 19.9347 34.1199 20.1998 34.1199H21.8318L22.5998 30.2799H18.2798C16.5871 30.2799 15.1868 29.0282 14.9539 27.3999H35.0458C34.8129 29.0282 33.4125 30.2799 31.7198 30.2799H27.6108Z",
    fill: "#2E3E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9199 26.4399V16.3599C14.9199 15.5646 15.5646 14.9199 16.3599 14.9199H33.6399C34.4352 14.9199 35.0799 15.5646 35.0799 16.3599V26.4399H14.9199Z",
    fill: "#385CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktopIcon.d73ba8e4d0d946a3e5f4031e22e10ebb.svg";
export { ForwardRef as ReactComponent };